import React from 'react';

const PermissionGate = ({
  children,
  requireOwner = false,
  requireMember = false,
  requireAdmin = false,
  isOwner = false,
  isMember = false,
  isAdmin = false,
}) => {
  if (requireOwner && !isOwner) return null;
  if (requireMember && !isMember) return null;
  if (requireAdmin && !isAdmin) return null;
  return <>{children}</>;
};

export default PermissionGate;
